import { render, staticRenderFns } from "./Answer.vue?vue&type=template&id=a83b6a18&scoped=true"
import script from "./Answer.vue?vue&type=script&lang=js"
export * from "./Answer.vue?vue&type=script&lang=js"
import style0 from "./Answer.vue?vue&type=style&index=0&id=a83b6a18&prod&lang=less&scoped=true"
import style1 from "./Answer.vue?vue&type=style&index=1&id=a83b6a18&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83b6a18",
  null
  
)

export default component.exports